import { ReactNode, useEffect, useState } from 'react';
import back4app2 from '../back4app2';
import { BACK4APP_DOT_COM_DASHBOARD_URL } from '../settings';
import LoadingMessage from './LoadingMessage';

interface Props {
  children: ReactNode;
}

export default function RequireAgentSubscription({ children }: Props) {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const redirectToApps = () => {
      window.location.replace(`${BACK4APP_DOT_COM_DASHBOARD_URL}/apps`);
    };

    (async () => {
      try {
        const subscription = await back4app2.getMyAgentsSubscription();
        if (cancelled) return;
        if (subscription?.planType && subscription.planType !== 'FREE') {
          setAllowed(true);
        } else {
          redirectToApps();
        }
      } catch {
        if (cancelled) return;
        redirectToApps();
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!allowed) {
    return <LoadingMessage message="Loading…" />;
  }

  return <>{children}</>;
}
